module.exports = __webpack_public_path__ + "img/tv-02.5e11fe58.svg";